<template>
    <div style="padding-top: 5rem;">
        <div class="full_loading" v-if="loading">
            <van-loading type="spinner" />
        </div>
        <div class="user_center_header">
            <van-icon name="arrow-left" class="back" @click="$router.go(-1)"/>
            订单详情
        </div>
        <div class="info_detail" v-if="info">
        <div class="info_status">
            <div v-if="info.status == 0">
                <div style="display: flex;align-items: center;">
                    <van-image :src="require('../../assets/bx/acc/order_2.png')" />
                    待支付</div>
                <div class="left_times">剩余时间&nbsp;
                    <van-count-down :time="countdown(info.ctime)" @finish="finish">
                        <template #default="timeData">
                            <span
                                class="block">{{ (timeData.days*24*60 + timeData.hours*60 + timeData.minutes) < 10? '0'+ (timeData.days*24*60 + timeData.hours*60 +timeData.minutes): (timeData.days*24*60 + timeData.hours*60 + timeData.minutes) }}</span>
                            <span class="colon">:</span>
                            <span
                                class="block">{{timeData.seconds < 10 ? '0'+ timeData.seconds : timeData.seconds }}</span>
                        </template>
                    </van-count-down>
                </div>
            </div>  
            
            <div v-else-if="info.status == 1">
                <span v-if="info.deliver_status == 0">
                    <van-image :src="require('../../assets/bx/acc/order_2.png')" />
                    待发货
                </span>
                <span v-if="info.deliver_status == 1">
                    <van-image :src="require('../../assets/bx/acc/order_1.png')" />
                    交易完成
                </span>
                <span v-if="info.deliver_status == 2 || info.deliver_status == 3">
                    <van-image :src="require('../../assets/bx/acc/order_3.png')" />
                    已取消
                </span>
                <span class="deliver_10_1" v-if="info.deliver_status == 10">
                    <van-image :src="require('../../assets/bx/warning.png')" />
                    角色转移遇到问题<br>
                </span>
                <p class="deliver_10" v-if="info.deliver_status == 10">系统未能自动完成角色发货，请不用担心，您的资金非常安全</p>
            </div>
            <span v-else-if="info.status == 2">
                <van-image :src="require('../../assets/bx/acc/order_3.png')" />
                支付失败
            </span>
            <span v-else-if="info.status == 3">
                <van-image :src="require('../../assets/bx/acc/order_3.png')" />
                取消订单
            </span>
        </div>
        <div class="box">
            <p class="tit">{{ info.app_name }}</p>
            <div class="cont">
                <van-image class="icon" :src="info.icon" />
                <div class="info">
                    <p class="p1">交易类型：{{info.goods_type_name}}</p>
                    <p class="p2">角色名：{{info.role_name}}</p>
                    <p class="p3">{{ info.server_name }}<i v-if="info.system_type_name">{{ info.system_type_name }}</i>
                    </p>
                </div>
            </div>
            <div v-if="orderType == 1">
                <p class="price1">
                    <span>成交价：</span>
                    <span><i>&yen;</i>&nbsp;{{ info.price }}</span>
                </p>
                <p class="price2">
                    <span>扣除服务费：</span>
                    <span><i>&yen;</i>&nbsp;{{ info.charge || 0 }}</span>
                </p>
                <div class="price">实收：&nbsp;<i>&yen;&nbsp;</i><span>{{ (Number(info.price) - Number(info.charge || 0)).toFixed(3) }}</span></div>
            </div>
            <div v-else-if="orderType == 2">
                <div class="price">实付款：&nbsp;<i>&yen;&nbsp;</i><span>{{ info.price }}</span></div>
            </div>
            <div v-else>
                <div class="price">售价：&nbsp;<i>&yen;&nbsp;</i><span>{{ info.price }}</span></div>
            </div>
        </div>
        <div class="info_msg">
            <div class="tit">订单信息</div>
            <p><em>收货信息：</em>{{info.mobile | plusX}}</p>
            <p><em>收货 Q Q：</em>{{info.qq}}</p>
            <p class="order_num">
                <span><em>订单编号：</em>{{info.order_num}}</span>
                <span class="copy" @click="copy(info.order_num)">复制</span>
            </p>
            <p v-if="info.pay_time"><em>付款时间：</em>{{info.pay_time}}</p>
            <p v-if="info.deliver_time"><em>发货时间：</em>{{info.deliver_time}}</p>
            <p v-if="info.deliver_account"><em>收货账号：</em>{{info.deliver_account}}</p>
        </div>
        <p style="padding: 0 1rem" v-if="info.deliver_status == 1">
            <van-icon name="warning" color="var(--theme)" />
            <span style="color:#666;font-size: 1.2rem;margin-left: 0.25rem;">为了您的账号安全，登录后请及时修改您的密码</span>
        </p>

        <div class="next_deliver_10" v-if="info.deliver_status == 10">
            <p>下一步该怎么办？</p>
            <ul>
                <li>
                    <em></em>
                    我们的客服人员已经收到通知，将<i>优先为您处理</i>。
                </li>
                <li>
                    <em></em>
                    请您也<i>主动联系客服</i>，以便最快速度为您手动完成发货。
                </li>
            </ul>
        </div>

        <van-button class="link" color="var(--theme)" v-if="info.deliver_status == 0 || info.deliver_status == 10" @click="kefu">
            <van-image class="icon kefu" :src="require('../../assets/bx/acc/kefu.png')" />
            联系客服
        </van-button>

        <div class="aqcn" v-if="info.deliver_status == 10">
            <img src="../../assets/bx/safe_2.png" alt="">
            安全承诺:您的款项由G买卖平台担保，仅在完成发货才会支付给卖家。本次异常已被记录，我们将全程负贡到底!
        </div>

        <van-button round color="var(--theme)" class="continue_pay" @click="continue_pay(info.price,userData.balance)" v-if="info.status == 0">
            继续付款</van-button>
        </div>
    </div>
</template>

<script>
    import crypto from "crypto";
    import Fingerprint2 from 'fingerprintjs2'
    export default {
        data() {
            return {
                info: null,
                currentServeTime: '',
                //倒计时  15分钟
                interval_time: 900000,
                pay_type: '',
                pay_amount: '',
                pwd: '',
                loading: false
            }
        },
        filters: {
            plusX(str) {
                var x = "****";
                if (str) {
                    if (str.length >= 6) {
                        return str.substring(0, 3) + x + str.substring(str.length - 4, str.length)
                    } else {
                        return str;
                    }
                }
            },
        },
        computed: {
            order_num() {
                return this.$route.query.order_num
            },
            userData() {
                return this.$store.getters.state.userData || {};
            },
            differTime() {
                return this.$store.state.differTime;
            },
            access_token() {
                return this.$store.state.access_token
            },
            is_pay() {
                return this.$route.query.is_pay || null
            },
            orderType() {
                if(this.$route.query.type == 'sell') {
                    return 1
                }else {
                    return 2
                }
            }
        },
        created() {
            this.getTime()
            this.$store.dispatch("getUserData", true);
        },
        mounted() {
            this.getDetail(this.order_num)
        },
        methods: {
            getDetail(order_num) {
                var params = {order_num}
                if(this.is_pay) params.is_pay = this.is_pay
                this.$Ajax('order/detail-by-role', params).then(rs => {
                    if (rs.code == 200) {
                        this.info = rs.data
                    }
                })
            },
            copy(order_num) {
                var that = this
                this.$copyText(order_num).then(() => {
                    that.$toast("复制成功");
                });
            },
            //联系客服
            kefu() {
                window.location.href =
                    'https://livechathuyu.gmmsj.com/index/index/kefu?u=6265f471b483e&platform=8&game_id=8889&game_name=G买卖&uid=8_' +
                    this.userData.user_id + '&phone=' + this.userData.username
            },

            countdown(createtime) {
                let endtime = new Date(createtime.replace(/-/g, '/')).getTime() + this.interval_time;
                let now = new Date(this.currentServeTime).getTime();
                let left = endtime - now;
                return left;
            },
            getTime() {
                var now = new Date();
                this.currentServeTime = new Date(now.valueOf() - this.differTime);
            },
            finish() {
                this.info.status = 3
                this.$forceUpdate()
            },
            //继续支付
            continue_pay(price, balance) {
                this.$filterPop({
                    type: 'mixpay',
                    direction: 'up',
                    selection: {
                        price, 
                        balance
                    },
                    onSuccess: (e) => {
                        this.pay_type = e.pay_type
                        this.pay_amount = e.pay_amount
                        if(e.pay_type == 2) {
                            this.buy()
                            return
                        }
                        this.$filterPop({
                            type: 'password',
                            direction: 'up',
                            onFunc: (a) => {
                                this.pwd = a.password
                                this.buy()
                            }
                        })
                    }
                })
            },
            buy() {
                var that = this
                this.loading = true
                var params = {
                    order_num: this.info.order_num,
                    goods_id: this.info.goods_id,
                    pay_type: this.pay_type,
                    pay_amount: this.pay_amount,
                }
                if(this.pwd) {
                    params.password = this.pwd
                }
                this.$Ajax('v2/order/role-pay', params).then(rs => {
                    if (rs.code == 200) {
                        if(this.pay_type == 1) {
                            setTimeout(() => {
                                this.loading = false
                            }, 1000);
                            this.$router.push({
                                name: 'order.status',
                                query: {
                                    order_num: rs.data.order_num
                                }
                            })
                            return
                        }
                        this.$Ajax('pay/pay', {
                            orderNum: rs.data.balance_order_num,
                            payType: 'alipay',
                            scene: 'wap',
                            type: 'balance'
                        }).then(res => {
                            setTimeout(() => {
                                this.loading = false
                            }, 1000);
                            if (res.code == 200) {
                                var timestamp = Date.parse(new Date()) / 1000
                                var uuids = this.uuid();
                                const request_id = this.MD5(that.access_token + uuids + timestamp);
                                var udid = this.udid
                                var sign = this.sign({
                                    orderNum: rs.data.balance_order_num,
                                    payType: 'alipay',
                                    scene: 'wap',
                                    type: 'balance',
                                    udid,
                                    request_id,
                                    timestamp,   
                                })
                                window.location.href = this.$BaseURL + res.data.url + '&udid=' + udid + '&request_id=' + request_id + '&timestamp=' + timestamp + '&sign=' + sign
                            }
                        }).catch(() => {
                            setTimeout(() => {
                                this.loading = false
                            }, 1000);
                        })
                    } else {
                        setTimeout(() => {
                            this.loading = false
                        }, 1000);
                    }
                }).catch(() => {
                    setTimeout(() => {
                        this.loading = false
                    }, 1000);
                })
            },
            async getUdid() {
                var that = this
                const fp = await new Promise((resolve) => {
                    Fingerprint2.get((components) => {
                        const values = components.map((component, index) => {
                            if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不     一样
                                return component.value.replace(/\bNetType\/\w+\b/, '')
                            }
                            return component.value
                        })
                        // 生成最终id murmur 
                        // console.log(values,'使用的浏览器信息')  //使用的浏览器信息
                        const udid = Fingerprint2.x64hash128(values.join(''), 31)
                        // console.log(udid,'生成的标识码') //生成的标识码
                        that.udid = udid
                        resolve(udid);
                    })
                })
                return fp;
            },
            uuid() {
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8,
                    1); // bits 6-7 of the      clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                return uuid;
            },
            MD5(value) {
                return crypto.createHash("md5").update(value).digest("hex");
            },
            sign(params = {}) {
                const keys = Object.keys(params).sort();
                const signs = [];
                for (let key of keys) {
                    if (params[key] == null) continue;
                    signs.push(key + '=' + params[key]);
                }
                return this.MD5(signs.join("&") + 'AfkRZKZs2LxuscnNUbpQrWppJvx48GEg');
            },
        },
        watch: {},
    }
</script>

<style lang="less" scoped>
    .full_loading {
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 999999999;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .user_center_header {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 525px;
        height: 22.5rem;
        background: url(../../assets/version_1.3.0/index/linear.png) no-repeat 0 -3.7rem / 100% 26.2rem;
        z-index: 1;
        padding: 1rem;
        text-align: center;
        color: #fff;
        font-size: 1.7rem;
        .back {
            position: absolute;
            top: 1.5rem;
            left: .8rem;
            font-size: 2rem;
            cursor: pointer;
        }
    }
    .info_detail {
        // margin-top: 5rem;
        padding-bottom: 7rem;
        position: relative;
        z-index: 2;
        max-height: calc(var(--vh, 1vh) * 100 - 5rem);
        overflow-y: auto;
        &::-webkit-scrollbar { 
            display: none; 
        }
    }

    .info_status {
        // background-color: #FFEFE4;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        color: #fff;
        font-size: 1.6rem;
        font-weight: 700;
        padding: 1.4rem 0;
        border-top-left-radius: .5rem;
        border-top-right-radius: .5rem;
        z-index: 101;
        // position: sticky;
        // top: 5rem;
        // transform: translateY(-.5rem);

        // &::after {
        //     content: '';
        //     width: 100%;
        //     height: 2rem;
        //     border-radius: 3rem;
        //     position: absolute;
        //     bottom: -1rem;
        //     left: 0;
        //     background-color: var(--innerbgc);
        // }

        span {
            display: flex;
            align-items: center;
        }

        .van-image {
            width: 2.4rem;
            height: 2.6rem;
            margin-right: .8rem;
        }
    }

    .box {
        position: relative;
        margin: 0 1rem 1.6rem;
        border-radius: 1rem;
        background-color: #fff;
        padding: 1rem;

        .tit {
            font-size: 1.4rem;
            color: #000;
            font-weight: 700;
            margin-bottom: 1rem;
        }

        .cont {
            display: flex;
            align-items: flex-start;
            margin-bottom: 1.5rem;
            .icon {
                width: 9rem;
                height: 9rem;
                border-radius: 1.2rem;
                overflow: hidden;
                margin-right: 1rem;
            }

            .info {
                line-height: 1.6;

                .p1 {
                    font-size: 1.4rem;
                    color: #000;
                    font-weight: 700;
                }

                .p2 {
                    font-size: 1.4rem;
                    color: #999;
                }

                .p3 {
                    font-size: 1.2rem;
                    color: #999;
                }
            }
        }
        .price1,
        .price2 {
            font-size: 1.4rem;
            color: #9e9e9e;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5rem;
            i {
                font-size: 1.2rem;
            }
        }
        .price1 {
            span:nth-last-child(1) {
                color: #000;
            }
        }
        .price {
            text-align: end;
            font-size: 1.4rem;
            color: #000;

            i {
                font-size: 1.2rem;
            }

            span {
                font-size: 1.8rem;
                font-weight: 700;
            }
        }
    }

    .info_msg {
        position: relative;
        margin: 0 1rem 1rem;
        border-radius: 1rem;
        background-color: #fff;
        border-radius: 1rem;
        padding: 1.8rem 1rem;

        .tit {
            font-size: 1.4rem;
            font-weight: 700;
            color: #000;
            margin-bottom: 1.2rem;
        }

        p {
            margin-bottom: .8rem;
            font-size: 1.4rem;
            color: #000;

            span {
                word-break: break-all;
            }

            em {
                color: #9e9e9e;
            }

            &.order_num {
                display: flex;
                align-items: flex-start;
                justify-content: space-between;

                span {
                    flex: 1;
                }

                .copy {
                    flex: unset;
                    font-size: 1.2rem;
                    color: var(--theme);
                    margin-top: 0.2rem;
                    width: 3rem;
                    text-align: center;
                }
            }
        }
    }

    .link {
        margin: 0 auto 1.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 35.5rem;
        padding: 0;
        border-radius: 1rem;
        overflow: hidden;
        font-size: 1.4rem;

        /deep/.van-button__text {
            display: flex;
            align-items: center;
        }

        .kefu {
            width: 2.4rem;
            margin-right: .5rem;
            margin-bottom: 0.2rem;
        }
    }

    .continue_pay {
        position: fixed;
        bottom: 2rem;
        left: 50%;
        transform: translateX(-50%);
        height: 3.4rem;
        padding: 0;
        width: 34.4rem;
        font-size: 1.4rem;
        z-index: 10;
    }

    .left_times {
        display: flex;
        align-items: center;
        font-size: 1.2rem;
        color: #000;

        .van-count-down {
            display: flex;
        }
    }

    .deliver_10_1 {
        display: flex;
        justify-content: center;
        font-size: 1.6rem;
        color: #F66F30;
        margin-bottom: .8rem;
        .van-image {
            width: 2.4rem;
            height: 2.4rem;
        }
    }
    .deliver_10 {
        color: #000;
        font-weight: normal;
        font-size: 1.2rem;
        text-align: center;
    }
    .next_deliver_10 {
        background-color: #fff;
        border-radius: 1rem;
        padding: 2rem 1rem;
        margin: 0 1rem .8rem;
        p {
            font-size: 1.4rem;
            font-weight: 700;
            color: #000;
            margin-bottom: 1rem;
        }
        ul {
            li {
                padding-left: 0.6rem;
                margin-bottom: 1rem;
                color: #606060;
                em {
                    width: .4rem;
                    height: .4rem;
                    border-radius: 50%;
                    background-color: #606060;
                    display: inline-block;
                    transform: translateY(-0.2rem);
                }
                i {
                    color: #EF4D3D;
                }
            }
        }
    }
    .aqcn {
        margin: 0.4rem 1rem;
        display: flex;
        align-items: flex-start;
        color: #A4A4A4;
        font-size: 1.2rem;
        img {
            width: 1.6rem;
            height: 1.6rem;
            margin-right: .3rem;
        }
    }
</style>